export default __webpack_public_path__ + "static/media/hero-caro-new-3.29219fca.png";